export enum Common {
  PartnerBotId = 108179,
}

export enum RidePeriod {
  afternoon = 1,
  morning = 2,
  allDay = 3,
}

export enum RecurrenceDay {
  everySunday = 1,
  everyMonday = 2,
  everyTuesday = 3,
  everyWednesday = 4,
  everyThursday = 5,
  everyFriday = 6,
  everySaturday = 7,
}

export enum LocalKeys {
  apiKey= 'apiKey',
  portalType= 'portalType',
  role= 'role',
  authToken= 'authToken',
  refreshToken= 'refreshToken',
  idToken= 'idToken',
  user= 'user',
  permissions= 'permissions',
  portalPermissions= 'portalPermissions',
}
export enum TableColumnsType {
  icon = 'icon',
  studentInstructions = 'studentInstructions',
  contacts = 'contacts',
  equipment = 'equipment',
  instructions = 'instructions',
  name = 'name',
  notes = 'notes',
  array = 'array',
  button = 'button',
  dropdown = 'dropdown',
  number = 'number',
}

export enum ActionType {
  added = 'added',
  modified = 'modified',
  removed = 'removed',
}
export enum TableColumnsDataType {
  date = 'date',
}

export enum TableNames {
  students = 'students',
  passengers = 'passengers',
}

export enum UserAcountTypes {
  Partner = 'Partner',
  Guardian = 'Guardian',
}

export enum SeverityLevel {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
  SECONDARY = 'secondary',
}

export enum RideType {
  outbound = 'outbound',
  return = 'return'
}

export enum StopPlaceType {
  School = 'School',
  Home = 'Home'
}

export enum PassengerType {
  Student = 'Student',
  Monitor = 'Monitor'
}

export enum EquipmentsNeed {
  RequiredAndAssigned = 1,
  RequiredButNotAssigned = 2,
  NoEquipmentRequired = 3
}

export const EquipmentsNeedDescriptions = {
  [EquipmentsNeed.RequiredAndAssigned]: "Required and Assigned",
  [EquipmentsNeed.RequiredButNotAssigned]: "Required but not Assigned", 
  [EquipmentsNeed.NoEquipmentRequired]: "No Equipment Required"
} as const;

export function getEquipmentsNeedDescription(value: number): string {
  return EquipmentsNeedDescriptions[value as EquipmentsNeed];
}
